<template>
	<div class="content">
		<router-view />
	</div>
</template>

<script>
	export default {
		created() {
			if (!this.allow_user("super-admin|operation-admin|payment-admin")) {
				this.$router.replace("/");
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/Payments.vue